import {Bar, Circular, Dots} from './components';

export default {
    Bar,
    Circular,
    Dots
};
